export const environment = {
  type: 'dev',
  production: false,
  staticUrl: 'https://static.deamicis.cloud',
  apiUrl: 'https://dev-api.deamicis.cloud',
};
